import React, { Component } from 'react'
import './App.css'
import './App.mobile.css'
import './utils/toast.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import AppRouter from './routing/AppRouter.tsx';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import TabletOrientationGuard from './components/TabletOrientationGuard.tsx';
import axios from 'axios';
import { Modal } from 'antd';
import { ConfigProvider } from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';
import { resetInitialization } from './services/appInitializer.ts';

// antd-mobile locale: English base with Serbian Latin overrides
const mobileLocale = {
  ...enUS,
  common: {
    ...enUS.common,
    confirm: 'Potvrdi',
    cancel: 'Otkaži',
    loading: 'Učitavanje',
    close: 'Zatvori',
  },
  PullToRefresh: {
    pulling: 'Povucite nadole za osvežavanje',
    canRelease: 'Pustite za osvežavanje',
    complete: 'Osveženo',
  },
  InfiniteScroll: {
    noMore: 'Nema više',
    failedToLoad: 'Učitavanje nije uspelo',
    retry: 'Pokušaj ponovo',
  },
  Dialog: { ok: 'U redu' },
  Modal: { ok: 'U redu' },
};

// Show upgrade prompt when server responds with PLAN_REQUIRED 403
axios.interceptors.response.use(
    response => response,
    error => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';

    if (status === 401) {
      const ignoredAuthEndpoints = ['/api/login', '/api/authenticated', '/api/logout'];
      const isIgnoredAuthRequest = ignoredAuthEndpoints.some(endpoint => requestUrl.includes(endpoint));

      if (!isIgnoredAuthRequest) {
        // Reset state — AuthenticatedLayout detects user === undefined and calls
        // history.replace('/login') (soft nav), avoiding a hard reload that would
        // clear the isLoggedOut guard and trigger another round of 401 requests.
        resetInitialization();
      }
    }

        if (error.response?.status === 403 && error.response?.data?.error === 'PLAN_REQUIRED') {
            const { requiredPlan, message } = error.response.data;
            Modal.warning({
                title: 'Nadogradnja plana je potrebna',
                content: message || `Ova funkcija zahteva ${requiredPlan || 'viši'} plan. Kontaktirajte administratora za nadogradnju.`,
            });
        }
        return Promise.reject(error);
    }
);


class App extends Component {

  render() {
    return (
      <ErrorBoundary sectionName="App">
        <ConfigProvider locale={mobileLocale}>
          <TabletOrientationGuard>
            <AppRouter/>
          </TabletOrientationGuard>
        </ConfigProvider>
      </ErrorBoundary>
    )
  }
}
export default App